<section class="retailer-deals-page">
  <!-- Breadcrumb / heading -->
  <div class="container fw-b d-flex justify-content-between align-items-center retailer-deals-header">
    <app-linker-route
      [headingName]="headingName"
      [linkerRouteItems]="linkerRouteItems">
    </app-linker-route>

    <button
      type="button"
      class="btn btn6 primary-action-btn"
      id="asd"
      routerLink="/retailer-add-deals">
      <i class="fa fa-plus" aria-hidden="true"></i>
      <span>Add Deals</span>
    </button>
  </div>

  <!-- Main layout -->
  <div class="container wrapper-content retailer-deals-shell">
    <div class="retailer-deals-layout">
      <!-- Left: category / filters -->
      <aside class="left-container mt-4 mb-3 scrol">
        <div class="ex1">
          <div id="accordion">
            <menu-panel
              [categoryListArray]="categoryListArrayss"
              (onSubCategory)="getSubCategoryList($event)"
              (onSelectSubCategody)="getSubCateGoryData($event)">
            </menu-panel>
          </div>
        </div>
      </aside>

      <!-- Right: deals cards -->
      <section class="right-container">
        <!-- Toolbar (matched to retailer-product-list) -->
        <div class="retailer-products-toolbar">
          <div class="toolbar-text-group">
            <p class="toolbar-eyebrow">Your Deals</p>
            <h2 class="toolbar-title">Retailer deals</h2>
            <p class="toolbar-subtitle">
              Manage your active deals, update listings, or add new promotional offers.
            </p>
          </div>
          <div class="toolbar-meta">
            <span class="toolbar-chip">
              {{ totalItems || 0 }} deal{{ (totalItems || 0) === 1 ? '' : 's' }}
            </span>
          </div>
        </div>
        <!-- Deals grid -->
        <div class="deals-grid" *ngIf="categoryListArray?.length > 0">
          <div
            class="card-container"
            *ngFor="let item of categoryListArray | paginate:{itemsPerPage:itemPerPage, currentPage: currentPage, totalItems: totalItems}; let j = last">
            <deals-card
              [isImage]="true"
              width="100%"
              height="240px"
              [data]="item"
              (on_Click)="forID($event)"
              (on_Click_Edit)="forEditDeals(item?._id)"
              [showEdit]="true">
            </deals-card>
          </div>
        </div>

        <!-- Skeleton grid -->
        <div class="deals-grid skeleton-grid" *ngIf="!categoryListArray?.length && !isLoading">
          <div
            class="card-container"
            *ngFor="let item of length(16)">
            <deals-card
              [isImage]="false"
              width="100%"
              height="240px"
              [data]="item">
            </deals-card>
          </div>
        </div>

        <!-- Empty / loading state -->
        <div
          class="deals-empty-state d-flex align-items-center m-auto"
          *ngIf="!categoryListArray?.length && isLoading">
          <p>No Data Found</p>
        </div>
      </section>
    </div>

    <!-- Pagination -->
    <div class="custom-pagination mt-2 pagin22 retailer-deals-pagination" *ngIf="totalItems > 20">
      <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
    </div>
  </div>
</section>